import { Fragment, useEffect, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { useColorMode } from '@chakra-ui/react';

const ApplyTheme = ({ theme, children }) => {
    const { colorMode, setColorMode } = useColorMode();
    const darkMode = theme.settings?.darkMode;

    //Update the CSS Variables
    const updateCSSVariables = (theme) => {
        const arrayOfVariableKeys = Object.keys(theme.theme);
        const arrayOfVariableValues = Object.values(theme.theme);

        //Loop through each array key and set the CSS Variables
        arrayOfVariableKeys.forEach((cssVariableKey, index) => {
            //Based on our snippet from MDN
            document.documentElement.style.setProperty(
                cssVariableKey,
                arrayOfVariableValues[index],
            );
        });
    };

    //On Component Mount and Component Update
    useLayoutEffect(() => {
        updateCSSVariables(theme);
    }, [theme]);

    // Keep Chakra's color mode in sync with the redux theme setting so the
    // app re-themes instantly on switch, without a window reload.
    useEffect(() => {
        const desiredMode = darkMode ? 'dark' : 'light';
        if (colorMode !== desiredMode) {
            setColorMode(desiredMode);
        }
    }, [darkMode, colorMode, setColorMode]);

    return <Fragment>{children}</Fragment>;
};

//Connect State To Props
const mapStateToProps = (state) => ({
    theme: state,
});
const connectedApplyTheme = connect(mapStateToProps)(ApplyTheme);

export default connectedApplyTheme;
